import { toRelativeDateString as toRelativeDateStringBase } from "@forento/shared/utilities/date"

export function toRelativeDateString(date: Date): string {
	return toRelativeDateStringBase(date, "en")
}
